module.exports = __webpack_public_path__ + "static/logo-2b13a7ff89bf3c22e1509a75eaf10736.png";